import { Alert, Col, Container, Row } from 'react-bootstrap'
import React from 'react'
import classNames from 'classnames'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../common/integrations'
import { type AccountIntegrationConfigMappingType, getMappingTypeLabel } from '../../../../models/Account'

interface IntegrationAdminSettingsCustom {
  serviceId: IntegrationServiceId
  mappingType?: AccountIntegrationConfigMappingType
}

export const IntegrationAdminSettingsCustom: React.FC<IntegrationAdminSettingsCustom> = ({ serviceId, mappingType }) => {
  const integrationDisplayName = getIntegrationDisplayName(serviceId)
  return (
    <Container className={classNames({ 'py-3': mappingType })}>
      <Row>
        <Col>
          <Alert variant='warning' className='d-flex gap-3 align-items-center'>
            <i className='bi bi-info-square zocks-text-primary consent-settings-info-square' />
            <span className='zocks-text-gray-900'>
              {mappingType ? `The ${getMappingTypeLabel(mappingType)} mapping of this` : 'This'} {integrationDisplayName} integration was custom-built for your
              organization. For any configuration changes, please connect with your Implementation Manager or our Support Team.
            </span>
          </Alert>
        </Col>
      </Row>
    </Container>
  )
}
